declare const window: any

export const sessionStorageKey = '__auth_provider_user__'

export const removeSessionStorageKey = () => {
  window.sessionStorage.removeItem(sessionStorageKey)
}
